import { render, staticRenderFns } from "./CakeshopsNewStepTwo.vue?vue&type=template&id=0cfbf957&"
import script from "./CakeshopsNewStepTwo.vue?vue&type=script&lang=js&"
export * from "./CakeshopsNewStepTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports